// Bus muy simple (pub/sub) para lanzar toasts desde cualquier hook o
// componente sin tener que envolver la app en un Context Provider.
let listeners = [];
let idCounter = 0;

export function subscribeToasts(listener) {
    listeners.push(listener);
    return () => {
        listeners = listeners.filter((l) => l !== listener);
    };
}

export function showToast(message, { type = "success", duration = 3000 } = {}) {
    const toast = { id: ++idCounter, message, type, duration };
    listeners.forEach((l) => l(toast));
    return toast.id;
}

export function showSuccessToast(message) {
    return showToast(message, { type: "success" });
}
